module.exports = __webpack_public_path__ + "static/media/appStore.8463fbab.svg";